import { render, staticRenderFns } from "./ProjectDocumentTemplateEditForm.vue?vue&type=template&id=748f2722&"
import script from "./ProjectDocumentTemplateEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports